import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('nuzlio_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('nuzlio_token');
      localStorage.removeItem('nuzlio_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  verifyEmail: (data) => api.post('/auth/verify-email', data),
  resendVerification: (data) => api.post('/auth/resend-verification', data),
  getMe: () => api.get('/auth/me'),
};

export const propertiesAPI = {
  getAll: () => api.get('/properties'),
  getOne: (id) => api.get(`/properties/${id}`),
  create: (data) => api.post('/properties', data),
  update: (id, data) => api.put(`/properties/${id}`, data),
  remove: (id) => api.delete(`/properties/${id}`),
  getIncome: (id) => api.get(`/properties/${id}/income`),
};

export const bookingsAPI = {
  getAll: (params) => api.get('/bookings', { params }),
  getOne: (id) => api.get(`/bookings/${id}`),
  create: (data) => api.post('/bookings', data),
  update: (id, data) => api.put(`/bookings/${id}`, data),
  generateLink: (property_id) => api.post('/bookings/generate-link', { property_id }),
  getByToken: (token) => api.get(`/bookings/public-property/${token}`),
  getTodayCheckouts: () => api.get('/bookings/today-checkouts'),
};

export const dashboardAPI = {
  get: () => api.get('/dashboard'),
};

export const guestsAPI = {
  getAll: (params) => api.get('/guests', { params }),
};

export const incomeAPI = {
  get: () => api.get('/income'),
};

export const paymentsAPI = {
  create: (data) => api.post('/payments', data),
  upsertByBooking: (bookingId, data) => api.put(`/payments/booking/${bookingId}`, data),
};

export const subscriptionsAPI = {
  request: (data) => api.post('/subscriptions/request', data),
};

export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.patch(`/notifications/${id}/read`),
};

const adminApi = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminAPI = {
  login: (data) => adminApi.post('/admin/login', data),
  getStats: () => adminApi.get('/admin/stats'),
  updateUserPlan: (id, plan) => adminApi.patch(`/admin/users/${id}/plan`, { plan }),
  getPendingSubscriptions: () => adminApi.get('/admin/subscriptions'),
  approveSubscription: (id) => adminApi.patch(`/admin/subscriptions/${id}/approve`),
  rejectSubscription: (id) => adminApi.patch(`/admin/subscriptions/${id}/reject`),
};

export default api;
